// import React from "react";
// import { Star } from "lucide-react";
// import { MdCancel } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// const OrderCard = ({ order }) => {
//   const navigate = useNavigate();

//   return (
// <div className="border border-[#B5CAFF] rounded-xl p-4">

//   {/* TOP ROW */}
//   <div className="flex items-start gap-4">

//     {/* IMAGE */}
//     <img
//       src={order.image}
//       alt={order.productName}
//       className="w-14 h-20 rounded-lg object-cover border"
//     />

//     {/* TITLE + RATING */}
//     <div className="flex-1">
//       <p className="text-sm font-medium text-[#191C1F]">
//         {order.productName}
//       </p>

//       <div className="flex items-center gap-1 mt-1 text-xs">
//         {[1,2,3,4,5].map(i => (
//           <Star
//             key={i}
//             size={12}
//             className={`${
//               i <= Math.round(order.rating)
//                 ? "fill-[#FA8232] text-[#FA8232]"
//                 : "text-gray-300"
//             }`}
//           />
//         ))}
//         <span className="text-[#191C1F]">
//           {order.rating} Star Rating
//         </span>
//       </div>
//     </div>

//     {/* PRICE */}
//     <div className="text-sm self-center font-semibold text-[#191C1F]">
//       ₹{order.price}
//     </div>
//   </div>

//   {/* STATUS + DELIVERY (FULL WIDTH) */}
//   <div className="mt-3 text-sm">
//     <div className="flex items-center gap-1 font-medium">
//       {order.status === "cancelled" && (
//         <>
//           <span>Order cancelled</span>
//           <MdCancel size={14} className="text-[#FF3B30]" />
//         </>
//       )}
//       {order.status === "delivered" && (
//         <span className="text-green-600">Order delivered</span>
//       )}
//     </div>

//     <p className="text-xs text-[#676767] mt-1">
//       {order.deliveryText}
//     </p>
//   </div>

//   {/* DIVIDER */}
//   <div className="mt-3 pt-3 -mx-4 border-t border-[#B5CAFF] text-center">
//     <button
//     onClick={() => navigate(`/my-account/my-orders/${order.id}`)}
//     className="text-sm text-[#007BFF] font-medium hover:underline"
//     >
//     View details
//     </button>
//   </div>

// </div>

//   );
// };

// export default OrderCard;


import React from "react";
import { Star } from "lucide-react";
import { useNavigate } from "react-router-dom";

const statusConfig = {
  ordered: { text: "Order placed", color: "text-blue-600" },
  packaged: { text: "Order packaged", color: "text-indigo-600" },
  shipped: { text: "Order shipped", color: "text-orange-600" },
  delivered: { text: "Delivered", color: "text-green-600" },
  pending: { text: "Pending", color: "text-yellow-600" },
  cancelled: { text: "Order cancelled ❌", color: "text-red-600" },
  returnRequested: { text: "Return requested", color: "text-orange-600" },
  returnAccepted: { text: "Return accepted", color: "text-blue-600" },
  returned: { text: "Returned", color: "text-gray-600" }
};

const OrderCard = ({ order }) => {
  const navigate = useNavigate();
  const item = order.items[0];
  const status = statusConfig[order.status];
  const avgRating = item?.productId?.ratings?.avgRating || 0;
  const totalReviews = item?.productId?.ratings?.totalReviews || 0;

  return (
    <div className="border border-[#B5CAFF] rounded-xl p-4">

      {/* TOP */}
      <div className="flex gap-4">
        <img
          src={item.variantId.images[0]}
          alt={item.productId.productName}
          className="w-16 h-16 object-cover rounded-lg border"
        />

        <div className="flex-1 flex flex-col justify-between">
          <p className="text-sm font-medium">
            {item.productId.productName}
          </p>

        <div className="flex gap-1 mt-1 items-center">
          {[1, 2, 3, 4, 5].map((i) => (
            <Star
              key={i}
              size={12}
              className={
                i <= Math.round(avgRating)
                  ? "text-[#FA8232] fill-[#FA8232]"
                  : "text-gray-300"
              }
            />
          ))}

          {avgRating > 0 ? (
            <span className="text-xs text-gray-500">
              ({totalReviews})
            </span>
          ) : (
            <span className="text-xs text-gray-400">
              No rating yet
            </span>
          )}
        </div>

        </div>

        <div className="font-semibold">
          ₹{order.totalAmount}
        </div>
      </div>

      {/* STATUS */}
      <div className="mt-2 text-sm">
          <p className={`text-sm font-medium ${status?.color}`}>
            {status?.text}
          </p>
      </div>

      <div className="mt-2 text-sm">
      <p className="text-xs text-gray-500">
        Order created at{" "}
        {new Date(order.createdAt).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric"
        })}
      </p>
      </div>

      {/* ACTION */}
      <div className="mt-3 pt-3 border-t border-[#B5CAFF] -mx-4 px-4 text-center">

        <button
          onClick={() => navigate(`/my-account/my-orders/${order._id}`)}
          className="text-sm text-[#007BFF] font-medium"
        >
          View details
        </button>
      </div>
    </div>
  );
};

export default OrderCard;
